import { render } from "./Button.vue?vue&type=template&id=39ed6177&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=39ed6177&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ed6177"]])

export default __exports__